<p-chart type="bar" [height]="'70px'" [data]="chartData" [options]="chartOptions"></p-chart>
